import { defineRecipe } from '@chakra-ui/react'

export const assiduousSearchBarRecipe = defineRecipe({
  className: 'assiduous-search-bar',
  base: {
    bg: 'transparent',
    borderColor: 'input.search.border',
    borderRadius: '5px',
    borderStyle: 'solid',
    borderWidth: '1px',
    boxSizing: 'border-box',
    color: 'text.primary',
    fontSize: '10px',
    fontWeight: 'normal',
    h: '32px',
    lineHeight: '1',
    maxW: '150px',
    _placeholder: {
      color: 'text.muted',
      opacity: 1,
    },
    _focusVisible: {
      borderColor: 'action.primary.bg',
      borderWidth: '1.5px',
      boxShadow: 'none',
      outline: 'none',
    },
    _disabled: {
      bg: 'surface.subtle',
      borderColor: 'border.default',
      color: 'text.muted',
      cursor: 'not-allowed',
      opacity: 0.55,
    },
  },
})
